export default __webpack_public_path__ + "static/media/benefit_4.4f8c7b0e.png";